import React, { useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import TestCardsWrapper from '../../IntegrationPageSection/PreviewWrapper/TestCardsWrapper';
import IntegrationPageSectionContext from '../../IntegrationPageSection/StateManagement/IntegrationPageSectionContext';
import initFastlane from './initFastlane';
import clientLogger from '../../../lib/logger';
import { environmentSelector } from '../../../store/App/selectors';
import styles from '../Fastlane.module.less';
import Fastlane from './Fastlane';
import { modalStyleOverrideTempHack } from './helpers';

export default function FastlanePreviewWrapper() {
  const {
    SdkConfigurator: {
      sdkSettings: { clientAccessToken, sdkBaseUrl, clientId }
    },
    integrationType: type,
    fastlaneContext: {
      paymentComponent,
      paymentWatermark,
      cardComponent,
      identity,
      profile,
      setFastlaneContext
    },
    geoLocOverride
  } = useContext(IntegrationPageSectionContext);

  const nonce = useSelector((state) => state.app.nonce);
  const targetEnv = useSelector(environmentSelector);

  useEffect(() => {
    const sdkUrl = new URL('/sdk/js', sdkBaseUrl);
    const sdkParams = new URLSearchParams({
      'client-id': clientId,
      components: 'buttons,fastlane'
    });
    sdkUrl.search = sdkParams.toString();
    const paypalScript = document.createElement('script');
    paypalScript.setAttribute('src', sdkUrl.toString());
    paypalScript.setAttribute('data-sdk-client-token', clientAccessToken);
    paypalScript.setAttribute('nonce', nonce);
    paypalScript.setAttribute('defer', true);
    paypalScript.onload = async () => {
      const initialize = await initFastlane(targetEnv, geoLocOverride);
      setFastlaneContext({
        ...initialize,
        isLoading: false
      });

      // temp hack to be removed once SDK team fixes styling issue
      modalStyleOverrideTempHack();
    };
    paypalScript.onerror = (error) => {
      clientLogger.cal.error('CLIENT_ERROR', {
        message: `The script ${error.target.src} didn't load correctly.`
      });
      alert(`The script ${error.target.src} didn't load correctly.`);
    };
    document.head.appendChild(paypalScript);
    return () => {
      document.head.removeChild(paypalScript);
    };
  }, [clientId, clientAccessToken]);
  return (
    <div className={styles.preview_wrapper}>
      <div className={styles.fastlane_test_cards_container}>
        <TestCardsWrapper showRadioButtons={false} />
      </div>
      <Fastlane
        cardComponent={cardComponent}
        paymentComponent={paymentComponent}
        paymentWatermark={paymentWatermark}
        identity={identity}
        profile={profile}
        type={type}
      />
    </div>
  );
}
